module.exports = __webpack_public_path__ + "img/icon_addressBook.029e70ae.svg";